import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export default function CookieBanner() {
    const { t } = useLang();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        try {
            const v = localStorage.getItem("abnormal_cookie_consent");
            if (!v) setVisible(true);
        } catch { /* ignore */ }
    }, []);

    const decide = (value) => {
        try { localStorage.setItem("abnormal_cookie_consent", value); } catch { /* ignore */ }
        window.dispatchEvent(new CustomEvent("abnormal-consent", { detail: value }));
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div data-testid="cookie-banner" className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-lg z-[60] bg-zinc-950 border border-abnormal-acid/50 shadow-2xl">
            <div className="p-5 md:p-6">
                <div className="flex items-start gap-3 mb-3">
                    <Cookie size={20} className="text-abnormal-acid flex-shrink-0 mt-0.5" />
                    <button
                        onClick={() => decide("dismissed")}
                        aria-label="close"
                        data-testid="cookie-close"
                        className="ml-auto text-zinc-500 hover:text-white"
                    >
                        <X size={16} />
                    </button>
                </div>
                <p className="text-sm text-zinc-200 leading-relaxed">
                    {t("cookie.message")}{" "}
                    <Link to="/cookie-policy" data-testid="cookie-link-policy" className="text-abnormal-acid underline hover:text-white">
                        {t("cookie.messageLink")}
                    </Link>.
                </p>
                <div className="mt-4 flex flex-wrap gap-2">
                    <button
                        onClick={() => decide("all")}
                        data-testid="cookie-accept"
                        className="bg-abnormal-acid text-black uppercase tracking-wider text-xs font-bold px-4 py-2 hover:bg-abnormal-paper hover:text-black transition-colors"
                    >
                        {t("cookie.accept")}
                    </button>
                    <button
                        onClick={() => decide("essentials")}
                        data-testid="cookie-decline"
                        className="border border-white/30 text-white uppercase tracking-wider text-xs font-bold px-4 py-2 hover:border-white transition-colors"
                    >
                        {t("cookie.decline")}
                    </button>
                </div>
            </div>
        </div>
    );
}
